import React, { useEffect, useState } from "react";
import { FieldArray, useFormikContext } from "formik";
import { Table } from "react-bootstrap";
import {
  amountByPercent,
  calculateDiscount,
  calculateTax,
  percentByAmount,
} from "../../../../utils/utils";
import { DialogActions, InputAdornment } from "@material-ui/core";
import NumberFormat from "react-number-format";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchTax from "../../setup/finance/searchTax";
import _ from "lodash";
import { AttachMoney, Percent } from "@mui/icons-material";
import SearchItem from "../../inventory/items/searchItem";
import SearchUom from "../../inventory/items/searchUom";
import Illustration from "../../../../partials/content/Illustration";
import PoGoodsReceived from "../../inventory/procurement/purchase-order/purchaseOrderDetail/poGoodsReceived";
import SearchGlAccount from "../../setup/finance/searchGlAccount";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { TabPanel, TabView } from "primereact/tabview";
import IncomingInvoicePoItemList from "./incomingInvoicePoItemList";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Card } from "react-bootstrap";
import { Typography } from "@material-ui/core";
import Swal from "sweetalert2";
import SearchCostComponent from "../../setup/sales/cost-component/searchCostComponent";
function IncomingInvoiceItem({ property }) {
  const [itemIndex, setItemIndex] = useState(0);
  const [openSearchCostComp, setOpenSearchCostComp] = useState(false);
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [openSearchItemType, setOpenSearchItemType] = useState(false);
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [itemSelected, setItemSelected] = useState({
    purchaseOrderItemID: 0,
    item: { itemType: 0 },
  });
  const [openSearchTax, setOpenSearchTax] = useState(false);
  const [taxLevel, setTaxLevel] = useState("");
  const [openItemDocRel, setOpenItemDocRel] = useState(false);
  const [openSearchGlAccount, setOpenSearchGlAccount] = useState(false);
  const [accountProperty, setAccountProperty] = useState("");
  const [buttonGroupActive, setButtonGroupActive] = useState(0);
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {}, []);
  return (
    <React.Fragment>
      <FieldArray name={property}>
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values[property] && values[property].length > 0 ? (
                      <thead className="text-center">
                        <tr>
                          <th style={{ width: "20%" }}>Item Name</th>
                          {values.purchaseOrderID === 0 ? (
                            <th style={{ width: "10%" }}>Account</th>
                          ) : null}
                          <th style={{ width: "5%" }}>Quantity</th>
                          <th style={{ width: "10%" }}>Unit</th>
                          <th style={{ width: "20%" }}>Unit Price</th>
                          <th style={{ width: "15%" }}>Item Discount</th>
                          <th style={{ width: "20%" }}>Total Price</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody>
                      {values[property] && values[property].length > 0 ? (
                        values[property].map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <tr>
                                <td>
                                  {values.purchaseOrderID > 0 ? (
                                    <FormOutlinedNoMarginTextField
                                      value={`${item.itemCode} ${item.itemName}`}
                                      InputProps={{
                                        startAdornment:
                                          item.itemType > 0 ? (
                                            <InputAdornment position="start">
                                              <BootstrapTooltip
                                                title={item.itemTypeName}
                                              >
                                                <i
                                                  className={
                                                    item.itemType === 1
                                                      ? "fas fa-boxes text-success"
                                                      : item.itemType === 2
                                                      ? "fas fa-tools text-primary"
                                                      : item.itemType === 3
                                                      ? "fas fa-building text-info"
                                                      : item.itemType === 4
                                                      ? "fas fa-boxes text-warning"
                                                      : item.itemType === 5
                                                      ? "fas fa-boxes text-danger"
                                                      : null
                                                  }
                                                ></i>
                                              </BootstrapTooltip>
                                            </InputAdornment>
                                          ) : null,
                                        readOnly: true,
                                      }}
                                    />
                                  ) : (
                                    <FormArrayTextField
                                      arrayPropName={property}
                                      index={index}
                                      margin="none"
                                      propName="itemName"
                                    />
                                  )}
                                </td>
                                {values.purchaseOrderID === 0 ? (
                                  <td>
                                    <FormArrayTextField
                                      arrayPropName={property}
                                      index={index}
                                      margin="none"
                                      propName="accountName"
                                      readonly
                                      searchButton
                                      onSearchClick={() => {
                                        setItemIndex(index);
                                        setAccountProperty("invoiceItem");
                                        setOpenSearchGlAccount(true);
                                      }}
                                    />
                                  </td>
                                ) : null}
                                <td>
                                  <FormArrayTextField
                                    arrayPropName={property}
                                    index={index}
                                    propName="qty"
                                    quantityField
                                    margin="none"
                                    readonly={values.ID > 0 ? true : false}
                                    onBlur={() => {
                                      calculateDiscount(
                                        item.discountPercent,
                                        values,
                                        property,
                                        "percent",
                                        index,
                                        setFieldValue,
                                        "additionalCost"
                                      );
                                      calculateItemTotalPrice(
                                        setFieldValue,
                                        item,
                                        index
                                      );
                                    }}
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName={property}
                                    index={index}
                                    margin="none"
                                    propName="uomName"
                                    readonly
                                    searchButton={
                                      values.purchaseOrderID > 0 ? false : true
                                    }
                                    onSearchClick={() => {
                                      setItemIndex(index);
                                      setItemSelected(item);
                                      setOpenSearchUom(true);
                                    }}
                                  />
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName={property}
                                    index={index}
                                    margin="none"
                                    propName="unitPrice"
                                    currencyField
                                    currencyCode={values.currencyCode}
                                    readonly={
                                      values.purchaseOrderID > 0 ? true : false
                                    }
                                    onBlur={(value) => {
                                      calculateDiscount(
                                        item.discountPercent,
                                        values,
                                        property,
                                        "percent",
                                        index,
                                        setFieldValue,
                                        "additionalCost"
                                      );
                                      calculateItemTotalPrice(
                                        setFieldValue,
                                        item,
                                        index
                                      );
                                    }}
                                  />
                                </td>
                                <td>
                                  {item.discountAmountType === 1 ? (
                                    <FormArrayTextField
                                      arrayPropName={property}
                                      index={index}
                                      propName="discountPercent"
                                      margin="none"
                                      readonly={
                                        values.purchaseOrderID > 0
                                          ? true
                                          : false
                                      }
                                      onBlur={(value) => {
                                        calculateDiscount(
                                          value,
                                          values,
                                          property,
                                          "percent",
                                          index,
                                          setFieldValue,
                                          "additionalCost"
                                        );
                                        calculateItemTotalPrice(
                                          setFieldValue,
                                          item,
                                          index
                                        );
                                      }}
                                      percentButton
                                      onPercentClick={() => {
                                        setFieldValue(
                                          `${property}[${index}].discountAmountType`,
                                          2
                                        );
                                      }}
                                    />
                                  ) : (
                                    <FormArrayTextField
                                      arrayPropName={property}
                                      index={index}
                                      propName="discountAmount"
                                      margin="none"
                                      currencyField
                                      currencyCode={values.currencyCode}
                                      readonly={
                                        values.purchaseOrderID > 0
                                          ? true
                                          : false
                                      }
                                      onBlur={(value) => {
                                        calculateDiscount(
                                          value,
                                          values,
                                          property,
                                          "amount",
                                          index,
                                          setFieldValue,
                                          "additionalCost"
                                        );
                                        calculateItemTotalPrice(
                                          setFieldValue,
                                          item,
                                          index
                                        );
                                      }}
                                      amountButton
                                      onAmountClick={() => {
                                        setFieldValue(
                                          `${property}[${index}].discountAmountType`,
                                          1
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                                <td>
                                  <FormArrayTextField
                                    arrayPropName={property}
                                    index={index}
                                    margin="none"
                                    propName="totalPrice"
                                    currencyField
                                    currencyCode={values.currencyCode}
                                    readonly
                                  />
                                </td>
                                <td
                                  style={{ whiteSpace: "nowrap" }}
                                  className="text-center"
                                >
                                  {values.purchaseOrderID > 0 ? (
                                    <BootstrapTooltip title="Item Purchase Order Document Relation">
                                      <button
                                        type="button"
                                        className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                                        onClick={() => {
                                          setItemSelected(item);
                                          setOpenItemDocRel(true);
                                        }}
                                      >
                                        <i className="fas fa-list"></i>
                                      </button>
                                    </BootstrapTooltip>
                                  ) : null}
                                  {values.ID === 0 ? (
                                    <BootstrapTooltip
                                      title={
                                        item.deleteInd
                                          ? "Undo Delete"
                                          : "Delete A/P Invoice Item"
                                      }
                                    >
                                      <button
                                        type="button"
                                        className={`btn btn-icon btn-label-${
                                          item.deleteInd ? "warning" : "danger"
                                        } btn-md btn-circle mx-1`}
                                        onClick={() => {
                                          if (item.ID > 0) {
                                            setFieldValue(
                                              `${property}[${index}].deleteInd`,
                                              !item.deleteInd
                                            );
                                          } else {
                                            setItemIndex(0);
                                            remove(index);
                                          }
                                          calculateTotalPrice(
                                            index,
                                            !item.deleteInd,
                                            -1,
                                            false,
                                            []
                                          );
                                        }}
                                      >
                                        {item.deleteInd ? (
                                          <i className="fas fa-undo-alt"></i>
                                        ) : (
                                          <i className="fas fa-trash-alt"></i>
                                        )}
                                      </button>
                                    </BootstrapTooltip>
                                  ) : null}
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            className="text-center py-3"
                            colSpan={`${
                              values.purchaseOrderID === 0 ? "8" : "7"
                            }`}
                          >
                            <Illustration
                              imageSource="INVIFO Payment.png"
                              guidance="You don't have any Invoice items yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td
                          className="text-center py-3"
                          colSpan={`${
                            values.purchaseOrderID === 0 ? "8" : "7"
                          }`}
                        >
                          {values.purchaseOrderID === 0 ? (
                            <button
                              type="button"
                              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                              onClick={() => {
                                if (values.vendorID > 0) {
                                  push({
                                    ID: 0,
                                    itemType: 0,
                                    purchaseOrderItemID: 0,
                                    itemID: 0,
                                    itemType: 0,
                                    itemTypeName: "",
                                    itemCode: "",
                                    itemName: "",
                                    varCode: "",
                                    qty: 0,
                                    qtyLeft: 0,
                                    uomID: 0,
                                    uomName: "",
                                    unitPrice: 0,
                                    taxPercent: 0,
                                    taxAmount: 0,
                                    taxName: "",
                                    discountAmountType: 1,
                                    discountPercent: 0,
                                    discountAmount: 0,
                                    totalPrice: 0,
                                    expenseAccountID: 0,
                                    accountName: "",
                                    poItem: false,
                                    deleteInd: false,
                                    unRegItem: true,
                                  });
                                } else {
                                  Swal.mixin({
                                    customClass: {
                                      confirmButton:
                                        "btn btn-success btn-md btn-pill btn-bold",
                                    },
                                    buttonsStyling: false,
                                  }).fire({
                                    title: "Failed",
                                    text: "Please select Vendor first",
                                    icon: "error",
                                    showCloseButton: true,
                                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                                  });
                                }
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              Add A/P Invoice Item
                            </button>
                          ) : null}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            {values[property] && values[property].length > 0 ? (
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                  <Card>
                    <Card.Body className="py-0">
                      <Table borderless size="sm" responsive="xl">
                        <thead className="text-center">
                          {values.additionalCost &&
                          values.additionalCost.length > 0 ? (
                            <tr>
                              <th style={{ width: "40%" }}>Cost Name</th>
                              <th style={{ width: "25%" }}>Account</th>
                              <th style={{ width: "30%" }}>Cost Price</th>
                              <th>Actions</th>
                            </tr>
                          ) : null}
                        </thead>
                        <tbody>
                          {values.additionalCost &&
                          values.additionalCost.length > 0 ? (
                            values.additionalCost.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <FormArrayTextField
                                      arrayPropName="additionalCost"
                                      index={index}
                                      margin="none"
                                      propName="itemName"
                                      readonly
                                      searchButton={
                                        values.ID > 0 ? false : true
                                      }
                                      onSearchClick={() => {
                                        setItemIndex(index);
                                        setOpenSearchCostComp(true);
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <FormArrayTextField
                                      arrayPropName="additionalCost"
                                      index={index}
                                      margin="none"
                                      propName="accountName"
                                      readonly
                                      searchButton={
                                        values.ID > 0 ? false : true
                                      }
                                      onSearchClick={() => {
                                        setItemIndex(index);
                                        setAccountProperty("additionalCost");
                                        setOpenSearchGlAccount(true);
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <FormArrayTextField
                                      arrayPropName="additionalCost"
                                      index={index}
                                      margin="none"
                                      propName="costPrice"
                                      currencyField
                                      currencyCode={values.currencyCode}
                                      readonly={values.ID > 0 ? true : false}
                                      onBlur={() => {
                                        calculateItemTotalPrice(
                                          setFieldValue,
                                          null,
                                          -1
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{ whiteSpace: "nowrap" }}
                                    className="text-center"
                                  >
                                    {values.ID === 0 ? (
                                      <BootstrapTooltip title="Delete Additional Cost">
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                          onClick={() => {
                                            let additionalCost = [];
                                            additionalCost = [
                                              ...values.additionalCost,
                                            ];
                                            additionalCost = _.remove(
                                              additionalCost,
                                              function(value, indexArr) {
                                                return index !== indexArr;
                                              }
                                            );
                                            calculateTotalPrice(
                                              -1,
                                              false,
                                              index,
                                              !item.deleteInd,
                                              additionalCost
                                            );
                                            setFieldValue(
                                              `additionalCost`,
                                              additionalCost
                                            );
                                          }}
                                        >
                                          <i className="fas fa-trash-alt"></i>
                                        </button>
                                      </BootstrapTooltip>
                                    ) : null}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan="4">
                                <Illustration
                                  guidance="No additional cost"
                                  guidanceLeftIcon="fas fa-info-circle kt-font-success"
                                ></Illustration>
                              </td>
                            </tr>
                          )}
                          {values.ID === 0 ? (
                            <tr>
                              <td className="text-center py-3" colSpan="4">
                                <button
                                  type="button"
                                  className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                  onClick={() => {
                                    const additionalCost = [
                                      ...values.additionalCost,
                                    ];
                                    additionalCost.push({
                                      costComponentID: 0,
                                      itemID: 0,
                                      itemName: "",
                                      costPrice: 0,
                                      expenseAccountID: 0,
                                      accountName: "",
                                      deleteInd: false,
                                    });
                                    setFieldValue(
                                      "additionalCost",
                                      additionalCost
                                    );
                                  }}
                                >
                                  <i className="fas fa-plus-circle"></i>
                                  Additional Cost
                                </button>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </Table>
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography className="kt-font-bolder">
                                Additional Cost Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.addCostTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <Card>
                    <Card.Body className="pb-0">
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr className="border-bottom">
                            <td style={{ width: "25%" }}>
                              <Typography className="mb-3 kt-font-bolder">
                                Sub Total
                              </Typography>
                            </td>
                            <td style={{ width: "5%" }}></td>
                            <td style={{ width: "30%" }}></td>
                            <td style={{ width: "40%" }}>
                              <Typography
                                component="div"
                                className="mb-3 kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.subTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography component="div" className="my-3">
                                {values.purchaseOrderID === 0 ? (
                                  <React.Fragment>Discount</React.Fragment>
                                ) : (
                                  <NumberFormat
                                    value={values.discountPercent}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div>
                                        Discount{" ("}
                                        {value}
                                        {"%)"}
                                      </div>
                                    )}
                                  />
                                )}
                              </Typography>
                            </td>
                            <td>
                              {values.purchaseOrderID === 0 ? (
                                <React.Fragment>
                                  <div
                                    className="btn-group btn-group-sm my-2 float-right"
                                    role="group"
                                  >
                                    <BootstrapTooltip title="Input By Amount">
                                      <button
                                        type="button"
                                        className={`btn btn-${
                                          buttonGroupActive === 0
                                            ? "success"
                                            : "label-dark"
                                        } btn-sm btn-bold`}
                                        onClick={() => {
                                          setButtonGroupActive(0);
                                        }}
                                      >
                                        <AttachMoney />
                                      </button>
                                    </BootstrapTooltip>
                                    <BootstrapTooltip title="Input By Percentage">
                                      <button
                                        type="button"
                                        className={`btn btn-${
                                          buttonGroupActive === 1
                                            ? "success"
                                            : "label-dark"
                                        } btn-sm btn-bold`}
                                        onClick={() => {
                                          setButtonGroupActive(1);
                                        }}
                                      >
                                        <Percent />
                                      </button>
                                    </BootstrapTooltip>
                                  </div>
                                </React.Fragment>
                              ) : null}
                            </td>
                            <td>
                              {values.purchaseOrderID === 0 ? (
                                <React.Fragment>
                                  {buttonGroupActive === 0 ? (
                                    <FormTextField
                                      label="Discount Amount"
                                      name="discountAmount"
                                      currencyField
                                      currencyCode={values.currencyCode}
                                      readonly={
                                        values.paymentStatus > 1 ? true : false
                                      }
                                      onChangeValue={(value) => {
                                        calculateDiscount(
                                          value,
                                          values,
                                          property,
                                          "amount",
                                          -1,
                                          setFieldValue,
                                          "additionalCost"
                                        );
                                      }}
                                    />
                                  ) : buttonGroupActive === 1 ? (
                                    <FormTextField
                                      label="Discount Percent"
                                      name="discountPercent"
                                      percentageField
                                      readonly={
                                        values.paymentStatus > 1 ? true : false
                                      }
                                      onBlur={(value) => {
                                        calculateDiscount(
                                          value,
                                          values,
                                          property,
                                          "percent",
                                          -1,
                                          setFieldValue,
                                          "additionalCost"
                                        );
                                      }}
                                    />
                                  ) : null}
                                </React.Fragment>
                              ) : null}
                            </td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.discountAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      - {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography component="div" className="my-3">
                                {values.purchaseOrderID === 0 ? (
                                  <React.Fragment>Tax</React.Fragment>
                                ) : (
                                  <NumberFormat
                                    value={values.taxPercent}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div>
                                        Tax{" ("}
                                        {value}
                                        {"%)"}
                                      </div>
                                    )}
                                  />
                                )}
                              </Typography>
                            </td>
                            <td></td>
                            <td>
                              {values.purchaseOrderID === 0 ? (
                                <React.Fragment>
                                  <FormTextField
                                    label="Tax Percent"
                                    name="taxPercent"
                                    percentageField
                                    searchButton={
                                      values.paymentStatus > 1 ? false : true
                                    }
                                    readonly
                                    onSearchClick={() => {
                                      setTaxLevel("header");
                                      setOpenSearchTax(true);
                                    }}
                                  />
                                </React.Fragment>
                              ) : null}
                            </td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.taxAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Typography className="my-3">
                                Additional Cost
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.addCostTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                className="kt-font-bolder"
                              >
                                Grand Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.grandTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                </div>
              </div>
            ) : null}
          </React.Fragment>
        )}
      </FieldArray>
      <DialogLayout
        open={openSearchItemType}
        title="Select Item Type"
        onCloseDialog={() => {
          setOpenSearchItemType(false);
        }}
        maxWIdth="md"
      >
        <div className="row menu-row-modules mt-4">
          <div className="col-sm-4 col-md-4 col-lg-4">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setOpenSearchItemType(false);
                  setOpenSearchItem(true);
                  setTab({
                    ID: 1,
                    title: "Sellable Items",
                    icon: "fas fa-boxes",
                  });
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">Sellable Items</div>
                  <i className="fas fa-boxes fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setOpenSearchItemType(false);
                  setOpenSearchItem(true);
                  setTab({
                    ID: 2,
                    title: "Services",
                    icon: "fas fa-tools",
                  });
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">Services</div>
                  <i className="fas fa-tools fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4">
            <div className="menu-grid-square">
              <Card
                className="card-select-type"
                onClick={() => {
                  setOpenSearchItemType(false);
                  setOpenSearchItem(true);
                  setTab({
                    ID: 4,
                    title: "Assets",
                    icon: "fas fa-building",
                  });
                }}
              >
                <Card.Body>
                  <div className="menu-title mb-2">Assets</div>
                  <i className="fas fa-building fa-4x"></i>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchItemType(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchItem}
        title="Search Item"
        onCloseDialog={() => {
          setOpenSearchItem(false);
          setOpenSearchItemType(true);
        }}
        minHeight={true}
      >
        <SearchItem
          tab={tab}
          selectSellableItems={true}
          selectServiceItems={true}
          selectItemPackages={false}
          selectAssetItems={true}
          selectVariant={true}
          onSelectItem={(item, itemPackage, varCode, valueName) => {
            selectItem(item, itemPackage, varCode, valueName);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchItem(false);
              setOpenSearchItemType(true);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchTax}
        title="Search Tax"
        onCloseDialog={() => {
          setOpenSearchTax(false);
        }}
        maxWIdth="sm"
      >
        <SearchTax
          onSelectTax={(tax) => {
            if (taxLevel === "item") {
              calculateTax(
                tax.taxPercent,
                values,
                property,
                "percent",
                itemIndex,
                setFieldValue,
                "additionalCost"
              );
              calculateItemTotalPrice(
                setFieldValue,
                values[property][itemIndex],
                itemIndex
              );
              setFieldValue(`${property[itemIndex].taxName}`, tax.taxName);
            } else if (taxLevel === "header") {
              calculateTax(
                tax.taxPercent,
                values,
                property,
                "percent",
                -1,
                setFieldValue,
                "additionalCost"
              );
            }
            setOpenSearchTax(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchTax(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchUom}
        title="Search Unit of Measurement"
        onCloseDialog={() => {
          setOpenSearchUom(false);
        }}
        maxWIdth="sm"
      >
        <SearchUom
          onSelectUom={(uom) => {
            setFieldValue(`${property}[${itemIndex}].uomID`, uom.ID);
            setFieldValue(`${property}[${itemIndex}].uomName`, uom.uomName);
            setOpenSearchUom(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchUom(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openItemDocRel}
        title="Item Purchase Order Document Relation"
        onCloseDialog={() => {
          setOpenItemDocRel(false);
        }}
        minHeight={true}
      >
        <h3>
          {itemSelected.itemCode} {itemSelected.itemName}
        </h3>
        <TabView className="tabview" scrollable>
          <TabPanel header="Goods Received">
            <PoGoodsReceived
              poID={values.purchaseOrderID}
              poItemID={itemSelected.purchaseOrderItemID}
            />
          </TabPanel>
          <TabPanel header="Account Payable">
            <IncomingInvoicePoItemList
              poItemID={itemSelected.purchaseOrderItemID}
            />
          </TabPanel>
        </TabView>

        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenItemDocRel(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCostComp}
        title="Search Cost Component"
        onCloseDialog={() => {
          setOpenSearchCostComp(false);
        }}
        maxWIdth="md"
      >
        <SearchCostComponent
          onSelectCostComponent={(cost) => {
            setFieldValue(
              `additionalCost[${itemIndex}].costComponentID`,
              cost.ID
            );
            setFieldValue(
              `additionalCost[${itemIndex}].itemName`,
              cost.costComponentName
            );
            setOpenSearchCostComp(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCostComp(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchGlAccount}
        title="Search GL Account"
        onCloseDialog={() => {
          setOpenSearchGlAccount(false);
        }}
        maxWIdth="md"
      >
        <SearchGlAccount
          accountTypeID="7"
          onSelectGlAccount={(account) => {
            setFieldValue(
              `${accountProperty}[${itemIndex}].expenseAccountID`,
              account.ID
            );
            setFieldValue(
              `${accountProperty}[${itemIndex}].accountName`,
              account.accountName
            );
            setOpenSearchGlAccount(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchGlAccount(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function calculateTotalPrice(
    currIndex = -1,
    deleteInd = false,
    addCurrIndex = -1,
    addDeleteInd = false,
    additionalCost = []
  ) {
    const invoiceItem = [...values[property]];
    let subTotal = 0;
    let grandTotal = 0;
    let addCostTotal = 0;
    if (additionalCost.length === 0) {
      additionalCost = [...values.additionalCost];
    }

    invoiceItem.forEach((item, index) => {
      if (!item.deleteInd && (!deleteInd || currIndex !== index)) {
        subTotal += parseFloat(item.totalPrice);
      } else if (!deleteInd && item.deleteInd && currIndex === index) {
        subTotal += parseFloat(item.totalPrice);
      }
    });

    additionalCost.forEach((item, index) => {
      if (!item.deleteInd && (!addDeleteInd || addCurrIndex !== index)) {
        addCostTotal += parseFloat(item.costPrice);
      } else if (!addDeleteInd && item.deleteInd && addCurrIndex === index) {
        addCostTotal += parseFloat(item.costPrice);
      }
    });

    const discountPercent = percentByAmount(values.discountAmount, subTotal);
    const taxAmount = amountByPercent(
      values.taxPercent,
      subTotal - values.discountAmount
    );
    grandTotal = subTotal - values.discountAmount + taxAmount;
    grandTotal += addCostTotal;
    setFieldValue("additionalCost", additionalCost);
    setFieldValue(`subTotal`, subTotal);
    setFieldValue(`taxAmount`, taxAmount);
    setFieldValue(`discountPercent`, discountPercent);
    setFieldValue("grandTotal", grandTotal);
    setFieldValue(`addCostTotal`, addCostTotal);
  }

  function calculateItemTotalPrice(setFieldValue, item, index) {
    const invoiceItem = [...values[property]];
    const additionalCost = [...values.additionalCost];
    if (index >= 0) {
      const totalPrice = item.unitPrice * parseFloat(item.qty);
      invoiceItem[index].totalPrice =
        totalPrice - item.discountAmount + item.taxAmount;
      invoiceItem[index].minimumPrice =
        item.oriMinimumPrice * parseFloat(item.qty);
    }
    let subTotal = 0;
    let grandTotal = 0;
    let addCostTotal = 0;
    if (values) {
      invoiceItem.forEach((value) => {
        if (!value.deleteInd) {
          if (value.totalPrice > 0) {
            subTotal += parseFloat(value.totalPrice);
          }
        }
      });
    }
    additionalCost.forEach((value) => {
      if (!value.deleteInd) {
        if (value.costPrice > 0) {
          addCostTotal += parseFloat(value.costPrice);
        }
      }
    });
    const discountPercent = percentByAmount(values.discountAmount, subTotal);
    const taxAmount = amountByPercent(
      values.taxPercent,
      subTotal - values.discountAmount
    );
    grandTotal = subTotal - values.discountAmount + taxAmount;
    grandTotal += addCostTotal;
    setFieldValue(property, invoiceItem);
    setFieldValue(`taxAmount`, taxAmount);
    setFieldValue(`discountPercent`, discountPercent);
    setFieldValue(`subTotal`, subTotal);
    setFieldValue(`grandTotal`, grandTotal);
    setFieldValue(`addCostTotal`, addCostTotal);
  }

  function selectItem(item, itemPackage, varCode, valueName) {
    let invoiceItem = [...values[property]];
    if (item !== null) {
      invoiceItem[itemIndex] = {
        itemID: item.ID,
        grStatus: 1,
        itemType: item.itemType,
        itemTypeName: item.itemTypeName,
        itemCode: item.itemCode,
        itemName: item.itemName,
        varCode: varCode,
        qty: 0,
        totalPrQty: 0,
        uomID: 0,
        uomName: "",
        unitPrice: 0,
        discountPercent: 0,
        discountAmount: 0,
        taxPercent: 0,
        taxAmount: 0,
        taxName: "",
        totalPrice: 0,
        purchaseRequests: [],
        autoAdd: false,
        deleteInd: false,
      };
      setFieldValue(property, invoiceItem);
    }
    setOpenSearchItemType(false);
  }
}

export default IncomingInvoiceItem;
